import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

export default build([
	{
		path: "/chat/trucks",
		component: lazy(() => import("./ChatTrucksPage")),
	},
]);
